import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import ChevronDown from 'assets/chevron_down.svg?react';
import ChevronUp from 'assets/chevron_up.svg?react';
import { Select } from 'syngenta-digital-cropwise-react-ui-kit';

import { FUMIGATION_CODES } from 'screens/Integrations/CalAgIntegration/helpers/constants';
import getDropdownParentWithoutDetaching from 'screens/Applications&WorkOrders/StepsLayout/Helpers/getDropdownParentWithoutDetaching';

const FumigationField = ({ onChange, value, id, methodCodeItems }) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const fumigationItems = useMemo(() => {
    return methodCodeItems.map(code => ({
      value: code.method.toString(),
      label: code.description,
      key: code.method.toString(),
      checked: false
    }));
  }, [methodCodeItems]);

  return (
    <Select
      data-testid="fumigation-code-select"
      showSearch
      allowClear
      id={id}
      value={value}
      onChange={onChange}
      className="custom-select w-full"
      suffixIcon={
        isDropdownVisible ? (
          <ChevronUp width={18} height={18} />
        ) : (
          <ChevronDown width={18} height={18} />
        )
      }
      onDropdownVisibleChange={visible => setIsDropdownVisible(visible)}
      getPopupContainer={getDropdownParentWithoutDetaching}
    >
      {fumigationItems.map(code => (
        <Select.Option
          key={code.key}
          value={code.value}
          data-testid="fumigation-code-option"
        >
          <strong>{code.value}</strong>
          {` - ${code.label}`}
        </Select.Option>
      ))}
    </Select>
  );
};

FumigationField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string,
  methodCodeItems: PropTypes.arrayOf(
    PropTypes.shape({
      method: PropTypes.number.isRequired,
      description: PropTypes.string.isRequired
    })
  )
};

FumigationField.defaultProps = {
  value: undefined,
  id: '',
  methodCodeItems: FUMIGATION_CODES.fumigation
};

export default FumigationField;
